import type { QueryClient } from '@tanstack/react-query';

const PREFIX = 'dashweb:';
// Changed collection → query keys to invalidate (derived views included).
const COLLECTION_INVALIDATIONS: Record<string, string[][]> = {
  products: [['products'], ['pricing'], ['dashboard'], ['report']],
  pricing: [['pricing']],
  categories: [['categories'], ['products']],
  stock: [['stock'], ['dashboard'], ['report']],
  movements: [['movements'], ['report']],
  transfers: [['transfers'], ['report']],
  sales: [['dashboard'], ['report']],
  users: [['users']],
  branches: [['branches']],
  promotions: [['promotions']],
  audit: [['audit']],
  settings: [['settings'], ['report']],
};

/** Install once. Returns a cleanup fn. Same-origin tabs only (storage event scope). */
export function installCrossTabSync(qc: QueryClient): () => void {
  const handler = (e: StorageEvent) => {
    if (!e.key || !e.key.startsWith(PREFIX)) return;
    const collection = e.key.slice(PREFIX.length);
    const keys = COLLECTION_INVALIDATIONS[collection];
    if (!keys) return;
    for (const queryKey of keys) void qc.invalidateQueries({ queryKey });
  };
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
